import { createSigninOnReturnStore } from "@react/foundation/auth";

export const {
  signinOnReturnSelectors,
  signinOnReturnStore,
  useSigninOnReturnStore,
} = createSigninOnReturnStore();
